import { useGetHttp } from "../../http.hook";

type IResponse = unknown;

export function useNudgeEphemeralUserAdminHttp() {
  return useGetHttp<IResponse>({
    path: "/admin/campaigns/:campaignId/ephemeral-user/nudge",
  });
}
